module.exports = __webpack_public_path__ + "static/img/whriteLogo.9b894b07.png";